export const searchIcons = {
  search: 'assets/img/search.svg',
  arrowDown: 'assets/img/arrow_down.svg',
  union: 'assets/img/icon/Union.png',
  defaultImage: 'assets/img/default_news-img.svg'
};
